module.exports = __webpack_public_path__ + "static/media/wallet.376ba000.svg";